import { Modal } from "react-bootstrap";
import Styles from "./Confirmation.module.css";
import Loader from "../SharedComponents/Loader/Loader";
import cancelIcon from "../Assets/cross.png";

export const Confirmation = (props) => {
  return (
    <>
      <div className={Styles.parentContainer + " container-fluid"}>
        <div className="container">
          <Modal
            size={props?.isConfirmation ? "lg" : "xs"}
            show={props?.isOpen}
            onHide={props?.onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body
              style={
                props?.isConfirmation ? { minHeight: 250, padding: 30 } : {}
              }
            >
              <div className={Styles.cancelImgParentContainer}>
                <div>
                  <p
                    className="fontBold"
                    style={props?.isConfirmation ? { fontSize: 24 } : {}}
                  >
                    {props?.title ? props?.title : "Confirmation"}
                  </p>
                </div>
                <div className={Styles.cancelImgContainer}>
                  <img
                    onClick={props.onHide}
                    src={cancelIcon}
                    alt="cancel"
                    className={Styles.cancelImg}
                  />
                </div>
              </div>
              <div className={Styles.container}>
                {props?.isConfirmation || props?.showContent ? (
                  <p
                    style={
                      props?.isConfirmation
                        ? { marginTop: 40, fontSize: 18 }
                        : {}
                    }
                  >
                    {props?.content}
                  </p>
                ) : (
                  props?.dataKey?.map((item) => (
                    <div className={Styles.contentAlignment} key={item.key}>
                      <p className={Styles.titleContainer}>{item?.key}</p>
                      <p className={Styles.colonContainer}>:</p>
                      <p className={Styles.valueContainer}>
                        {item?.isAmount ? <span>₹</span> : null}{" "}
                        {props?.data?.[item.attribute] || "-"}{" "}
                        {item?.ispercentage ? <span>%</span> : null}
                      </p>
                    </div>
                  ))
                )}
              </div>

              <div
                className={Styles.btnContainer}
                style={
                  props?.isConfirmation
                    ? {
                        marginTop: 40,
                      }
                    : {}
                }
              >
                <button onClick={props?.onHide} className={Styles.Resetbtn}>
                  Cancel
                </button>
                {props?.isConfirmation ? (
                  <button onClick={props?.onSucess} className={Styles.btn}>
                    {props?.successBtn}
                  </button>
                ) : (
                  <button onClick={props?.onSucess} className={Styles.btn}>
                    Choose
                  </button>
                )}
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};
